import script from "./SwitchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchInput.vue?vue&type=script&setup=true&lang=js"

import "./SwitchInput.vue?vue&type=style&index=0&id=1bae5d89&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bae5d89"]])

export default __exports__